<template>
  <RevTable
    v-if="methods.length"
    class=""
    :collection="methods"
    :columns
    transparent-header
  >
    <template #body-markets="{ item }">
      <div class="flex flex-wrap gap-6">
        <div v-for="{ market, subMarkets } in sortMarkets(item)" :key="market">
          <FlagDisplayer v-if="!subMarkets.length" :market />
          <div v-else class="flex flex-wrap gap-6">
            <FlagDisplayer
              v-for="subMarket in subMarkets"
              :key="subMarket.subMarketCode"
              :is-country="false"
              :market="
                market === MarketCountryCode.JP
                  ? subMarket.subMarketName
                  : subMarket.subMarketCode
              "
            />
          </div>
        </div>
      </div>
    </template>
    <template #body-shippingProvider="{ item }">
      {{ getShippingProviderLabel(categoryGroupMetadata, item) }}
    </template>
    <template #body-preparationTime>
      {{ getPreparationTimeLabel(categoryGroupMetadata, getFormatHoursInDay) }}
    </template>
    <template #body-shippingTime="{ item }">
      {{ getShippingTimeLabel(item, getFormatHoursInDay) }}
    </template>
    <template #body-totalTime="{ item }">
      <span class="body-1-bold">
        {{
          getTotalTimeLabel(categoryGroupMetadata, item, getFormatHoursInDay)
        }}
      </span>
    </template>
    <template #body-price="{ item }">
      {{ getPriceLabel(i18n, isFree, item) }}
    </template>
  </RevTable>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTable } from '@ds/components/Table'

import { useFormatHours } from '~/composables/useFormatHours'

import categoryListTranslations from '../../CategoryList.translations'
import type {
  ShippingCategoryGroupMetadata,
  ShippingRuleMethod,
} from '../../CategoryList.types'
import {
  getPreparationTimeLabel,
  getPriceLabel,
  getShippingProviderLabel,
  getShippingTimeLabel,
  getTotalTimeLabel,
  sortMarkets,
} from '../../CategoryList.utils'
import FlagDisplayer from '../FlagDisplayer/FlagDisplayer.vue'
import type { FormMethodValues } from '../RuleDrawer/RuleDrawer.types'

import translations from './MethodList.translations'

const props = defineProps<{
  methods: (ShippingRuleMethod | FormMethodValues)[]
  isFree: boolean
  categoryGroupMetadata: ShippingCategoryGroupMetadata
}>()

const i18n = useI18n()
const { getFormatHoursInDay } = useFormatHours()

const hasSubMarkets = computed(() =>
  props.methods.some(({ markets }) =>
    markets.some(({ subMarkets }) => subMarkets.length),
  ),
)

const columns = [
  {
    key: 'markets',
    label: i18n(
      hasSubMarkets.value ? translations.states : translations.markets,
    ),
  },
  {
    key: 'shippingProvider',
    label: i18n(categoryListTranslations.shippingProvider),
  },
  { key: 'preparationTime', label: i18n(translations.preparationTime) },
  { key: 'shippingTime', label: i18n(categoryListTranslations.shippingTime) },
  { key: 'totalTime', label: i18n(translations.totalTime) },
  { key: 'price', label: i18n(categoryListTranslations.price) },
]
</script>
